"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = useScrollPosition;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _getWindowScrollPosition = _interopRequireDefault(require("../utils/getWindowScrollPosition"));
function useScrollPosition() {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    function handleScroll() {
      var value = (0, _getWindowScrollPosition["default"])();
      if (value !== position) {
        setPosition(function (p) {
          return value === p ? p : value;
        });
      }
    }
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, [position]);
  return position;
}